import React, { useState, useEffect } from 'react'; 
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import './Medicamento.css';

const PorcentajeGrasa = () => {
  const { idPaciente, visita } = useParams();
  const navigate = useNavigate();

  const tipoFormulario = `porcentaje_grasa_visita_${visita}`; // ✅ CORREGIDO

  const [porcentajeGrasa, setPorcentajeGrasa] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [formBloqueado, setFormBloqueado] = useState(false);
  const [formId, setFormId] = useState(null);

  useEffect(() => {
    const bloqueado = localStorage.getItem(`formulario_bloqueado_${idPaciente}_${visita}`);
    if (bloqueado === 'true') setFormBloqueado(true);
  }, [idPaciente, visita]);

  useEffect(() => {
    if (idPaciente && visita) fetchFormularioExistente();
  }, [idPaciente, visita]);

  const fetchFormularioExistente = async () => {
    try {
      const res = await fetch(`https://api.weareinfinite.mx/form/formularios/${idPaciente}/${tipoFormulario}`);
      if (!res.ok) throw new Error('Formulario no encontrado');

      const data = await res.json();
      const respuestas = data.respuestas || [];

      // Buscar respuesta por 'porcentaje_grasa'
      const respuesta = respuestas.find(r => r.id === 'porcentaje_grasa');

      if (respuesta) {
        console.log('Respuesta encontrada:', respuesta);
        setPorcentajeGrasa(respuesta.respuesta || '');
        setFormId(data._id); // Asumiendo que el id del formulario está en data._id
        setEditMode(true);
      } else {
        console.warn('No se encontró la respuesta de porcentaje_grasa');
      }

    } catch (error) {
      console.warn('No se encontró formulario previo:', error.message);
      setEditMode(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      idPaciente,
      tipoFormulario,
      visita,
      respuestas: [
        {
          id: 'porcentaje_grasa',
          respuesta: porcentajeGrasa,
          comentario: ''
        }
      ]
    };

    const url = editMode
      ? `https://api.weareinfinite.mx/form/formularios/${idPaciente}/${tipoFormulario}` // PUT por id específico
      : `https://api.weareinfinite.mx/form/formularios`; // POST nuevo

    const method = editMode ? 'PUT' : 'POST';

    try {
      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const result = await response.json();
        throw new Error(result.mensaje || 'Error al guardar el porcentaje de grasa');
      }

      Swal.fire({
        icon: 'success',
        title: editMode ? 'Actualizado' : 'Guardado',
        text: 'Porcentaje de grasa guardado correctamente.',
        timer: 2000,
        showConfirmButton: false,
      });

      navigate(`/cronograma/${idPaciente}`);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Ocurrió un error al guardar.',
      });
    }
  };

  const handleBloquear = () => {
    localStorage.setItem(`formulario_bloqueado_${idPaciente}_${visita}`, 'true');
    setFormBloqueado(true);
    Swal.fire({ icon: 'info', title: 'Formulario bloqueado' });
  };

  const handleDesbloquear = async () => {
    const { value: password } = await Swal.fire({
      title: 'Desbloquear formulario',
      input: 'password',
      inputLabel: 'Ingresa la contraseña',
      inputPlaceholder: 'Contraseña',
      showCancelButton: true
    });

    if (password === 'infinite') {
      localStorage.removeItem(`formulario_bloqueado_${idPaciente}_${visita}`);
      setFormBloqueado(false);
      Swal.fire('Desbloqueado', '', 'success');
    } else if (password !== undefined) {
      Swal.fire('Contraseña incorrecta', '', 'error');
    }
  };

  return (
    <div className="container">
      <h2>Porcentaje de Grasa</h2>
      <h3>Visita {visita}</h3>

      <form onSubmit={handleSubmit}>
        <label htmlFor="porcentajeGrasa">Ingrese el porcentaje de grasa:</label>
        <input
          type="text"
          id="porcentajeGrasa"
          value={porcentajeGrasa}
          onChange={(e) => setPorcentajeGrasa(e.target.value)}
          disabled={formBloqueado}
          required
        />

        <div style={{ marginTop: '1rem' }}>
          <button type="submit">{editMode ? 'Actualizar' : 'Guardar'}</button>
          <button type="button" onClick={() => navigate(`/cronograma/${idPaciente}`)}>Regresar</button>
        </div>

        <div className="botones-formulario">
          {formBloqueado ? (
            <button type="button" onClick={handleDesbloquear}>Desbloquear</button>
          ) : (
            <button type="button" onClick={handleBloquear}>Bloquear</button>
          )}
        </div>
      </form>
    </div>
  );
};

export default PorcentajeGrasa;
